import React, { Component } from 'react';
import { bool, object, arrayOf, func, string } from 'prop-types';
import pluralize from 'plur';
import { sortBy } from 'lodash';

import Annotation from './Annotation/Annotation';
import AddAnnotation from './AddAnnotation/AddAnnotation';

import createAnnotation from 'helpers/createAnnotation';
import removeAnnotation from 'helpers/removeAnnotation';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import {
  Drawer,
  DrawerSummary,
  IconWrapper,
  PencilIcon,
  Title,
  List,
  EmptyAnnotationArea,
} from './Annotations.style';

class Annotations extends Component {
  state = {
    shouldOpen: false,
    isExpanded: false,
  };

  static getDerivedStateFromProps(newProps, oldState) {
    /**
     * If prop `shouldOpen` differs from old state `shouldOpen`
     * expand the Annotations list.
     */
    if (Boolean(newProps.clickedNode) !== oldState.shouldOpen) {
      return {
        shouldOpen: true,
        isExpanded: true,
      };
    }

    /**
     * If the prop `shouldOpen`does not change let `isExpanded` determine
     * if the list is expanded.
     */
    return {
      shouldOpen: false,
      isExpanded: oldState.isExpanded,
    };
  }

  /**
   * Make a request to the helper that makes a call to the API.
   * After the annotation is created increase counter so we will refetch the new annotation.
   */
  handleCreateAnnotation = request =>
    createAnnotation(request)
      .then(() => this.props.increaseCount())
      .then(() => this.props.clearClickedNode());

  /**
   * Expand and collapse the list of annotations.
   */
  handleToggleList = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  /**
   * Remove the annotation based its id.
   */
  handleRemoveClick = id =>
    removeAnnotation(id).then(() => this.props.increaseCount());

  render() {
    const {
      annotationList,
      editModeEnabled,
      clickedNode,
      groupsWithData,
      showReference,
    } = this.props;
    const { isExpanded } = this.state;
    const sortedAnnotationsList = sortBy(
      annotationList,
      item => item.timestamp
    );

    const totalAnnotations = sortedAnnotationsList.length;
    const title = `${totalAnnotations} ${pluralize(
      'annotation',
      totalAnnotations
    )}`;

    return (
      <Drawer>
        <DrawerSummary onClick={this.handleToggleList}>
          <IconWrapper>
            <PencilIcon />
          </IconWrapper>
          <Title>{title}</Title>
          <IconWrapper>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconWrapper>
        </DrawerSummary>
        {isExpanded && (
          <List>
            {editModeEnabled &&
              clickedNode && (
                <AddAnnotation
                  date={clickedNode.date}
                  onCreateAnnotation={this.handleCreateAnnotation}
                  groupsWithData={groupsWithData}
                  showReference={showReference}
                />
              )}
            {totalAnnotations >= 1 &&
              sortedAnnotationsList.map(item => (
                <Annotation
                  key={item._id}
                  id={item._id}
                  groups={item.groups}
                  date={item.timestamp}
                  dateRange={item.time_selection}
                  title={item.title}
                  shortDescription={item.short_description}
                  editModeEnabled={editModeEnabled}
                  handleRemoveClick={this.handleRemoveClick}
                />
              ))}
            {totalAnnotations === 0 && (
              <EmptyAnnotationArea>
                <p>There are no annotations for the selected period.</p>
              </EmptyAnnotationArea>
            )}
          </List>
        )}
      </Drawer>
    );
  }
}

Annotations.defaultProps = {
  annotationList: [],
};

Annotations.propTypes = {
  editModeEnabled: bool,
  clickedNode: object,
  shouldOpen: bool,
  annotationList: arrayOf(object),
  increaseCount: func.isRequired,
  clearClickedNode: func.isRequired,
  groupsWithData: arrayOf(string).isRequired,
  showReference: bool,
};

export default Annotations;



// WEBPACK FOOTER //
// ./src/components/Annotations/Annotations.js